import * as React from "react";
import { styled, alpha } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
    BgBoxContainer: {
      display: "flex",
      width: "100%",
      height: "100%",
      alignItems: "stretch",
       [theme.breakpoints.down("sm")]: {
        display: "inline",
      },
    },
    displayBgPaper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
  
      backgroundColor: theme.palette.background.main,
      width: "40%",
      height: "100vh",
      [theme.breakpoints.down("lg")]: {
        display: "none",
        width: "0%",
      },
    },
  
    formBgPaper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
      width: "60%",
      height: "100vh",
      [theme.breakpoints.down("lg")]: {
        width: "100%",
      },
      [theme.breakpoints.down("md")]: {
        width: "100%",
        display: "flex",
        height: "100vh",
        overflow: "hidden",
      },
    },
  }));